import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  custodians: [],
  loading: false,
  error: null,
};

const custodianSlice = createSlice({
  name: "custodians",
  initialState,
  reducers: {
    setCustodians: (state, action) => {
      const sortData = action.payload;
      const sort = sortData?.sort((a, b) => (a.name > b.name ? 1 : -1));
      state.custodians = sort;
      state.loading = false;
      state.error = null;
    },
    addCustodian: (state, action) => {
      const newCustodian = action.payload;
      if (
        state?.custodians?.find(
          (a) => a?.custodianId !== newCustodian?.custodianId
        )
      ) {
        state.custodians = [...state.custodians, newCustodian];
        toast.success(`${newCustodian.name} added successfully`);
      }
      state.loading = false;
      state.error = null;
    },
    updateCustodian: (state, action) => {
      const updatedCustodian = action.payload;
      const existingCustodianIndex = state.custodians.findIndex(
        (a) => a?.custodianId === updatedCustodian?.custodianId
      );

      if (existingCustodianIndex !== -1) {
        state.custodians[existingCustodianIndex] = updatedCustodian;
        toast.success(`${updatedCustodian.name} updated successfully`);
      } else {
        state.custodians.push(updatedCustodian);
        toast.success(`${updatedCustodian.name} added successfully`);
      }
      state.loading = false;
      state.error = null;
    },
    deleteCustodian: (state, action) => {
      const custodianIdToDelete = action.payload?.custodianId;
      const custodianToDelete = state.custodians.find(
        (a) => a?.custodianId === custodianIdToDelete
      );
      
      state.custodians = state.custodians.filter(
        (a) => a?.custodianId !== custodianIdToDelete
      );
      
      if (custodianToDelete) {
        toast.success(`${custodianToDelete.name} deleted successfully`);
      }
      state.loading = false;
      state.error = null;
    },
    setCustodianLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCustodianError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setCustodians,
  addCustodian,
  updateCustodian,
  deleteCustodian,
  setCustodianLoading,
  setCustodianError,
} = custodianSlice.actions;

// Selectors
export const selectCustodians = (state) => state.custodians.custodians;
export const selectCustodiansLoading = (state) => state.custodians.loading;
export const selectCustodiansError = (state) => state.custodians.error;

export default custodianSlice.reducer;
